<template>
    <v-scale-transition>
        <v-sheet class="sheet-chat-container" v-if="chat.deveAbrirChat" width="450">
            <v-list class="chat-sheet-header pt-3">
                <v-list-tile v-if="chat.currentTabChat === 'tab-mensagens'">
                    <v-list-tile-action>
                        <v-btn icon @click.stop="$emit('tabClicked', 'tab-item-lote')">
                            <v-icon size="50">chevron_left</v-icon>
                        </v-btn>
                    </v-list-tile-action>
                    <v-list-tile-avatar size="40" color="secondary">
                        <span class="white--text title">{{destinatarioConversacao.iniciais}}</span>
                    </v-list-tile-avatar>

                    <v-list-tile-content>
                        <v-list-tile-title class="text-uppercase font-weight-bold">
                            {{destinatarioConversacao.nome}}
                        </v-list-tile-title>
                        <v-list-tile-sub-title class="primary--text text--darken-4 font-weight-bold" style="font-size: 11px;">
                            {{ conversacaoCompraDetalhes.processo }} | {{conversacaoCompraDetalhes.itemOuLoteDescricao}}
                        </v-list-tile-sub-title>
                    </v-list-tile-content>
                    <v-list-tile-action>
                        <v-chip :color="destinatarioConversacao.online ? 'green' : '#90A4AE'" style="color: white !important;">
                            <v-avatar>
                                <v-icon size="15" style="color: white !important;">fas fa-globe</v-icon>
                            </v-avatar>
                            {{destinatarioConversacao.online ? 'Online' : 'Offline'}}
                        </v-chip>
                    </v-list-tile-action>
                    <v-list-tile-action>
                        <v-btn icon @click.stop="$emit('fecharChat')">
                            <v-icon size="30">close</v-icon>
                        </v-btn>
                    </v-list-tile-action>
                </v-list-tile>

                <v-list-tile v-else>

                    <v-list-tile-content>
                        <v-list-tile-title class="text-uppercase font-weight-bold">
                            Chat Compra Direta
                        </v-list-tile-title>
                    </v-list-tile-content>

                    <v-list-tile-action>
                        <v-btn icon @click.stop="$emit('fecharChat')">
                            <v-icon size="30">close</v-icon>
                        </v-btn>
                    </v-list-tile-action>
                </v-list-tile>
            </v-list>
            <v-tabs class="tabs-chat pa-0"
                    color="secondary"
                    v-model="chat.currentTabChat"
                    @change="$emit('tabClicked', $event)"  style="background-color: transparent;">

                <v-tab :key="1" href="#tab-itens-lotes" style="color: white !important;"
                       active-class="primary--text font-weight-bold white"
                       class="tab-menu-item-lote-mensagem white--text text-uppercase">Itens/Lotes</v-tab>

                <v-tab :key="2" href="#tab-mensagens" class="tab-menu-item-lote-mensagem white--text" style="color: white !important;"
                       active-class="primary--text font-weight-bold white text-uppercase"
                       :disabled="!destinatarioConversacao.id">Mensagens</v-tab>

                <v-tab-item :key="1" value="tab-itens-lotes" class="pa-0">

                    <chat-item-lote-lista v-if="ehPerfilComprador">
                        <chat-item-lote v-for="(itemOuLote, chave) in resultados"
                                        :itemOuLote="itemOuLote"
                                        :key="chave" @fornecedorClicked="(pessoa) => $emit('fornecedorClicked', itemOuLote, pessoa)"/>
                    </chat-item-lote-lista>

                    <chat-item-lote-lista v-else>
                        <chat-item-lote-fornecedor :resultados="resultados" @itemLoteClicked="(itemOuLote) => $emit('itemLoteClicked', itemOuLote)"/>
                    </chat-item-lote-lista>

                </v-tab-item>
                <v-tab-item :key="2" value="tab-mensagens" class="pa-0">
                    <chat-mensagem-container>
                        <chat-mensagem v-for="(mensagem, chave) in mensagensConversacao"
                                       :mensagem="mensagem"
                                       :key="chave"/>
                    </chat-mensagem-container>

                </v-tab-item>
            </v-tabs>
            <v-slide-y-transition duration="5">
                <div class="acoes-enviar-mensagem px-2 ma-0 py-0 transition-ease-in-out" v-if="chat.currentTabChat === 'tab-mensagens'">
                    <acoes-enviar-mensagem
                        :itemOuLote="itemOuLoteAtualDoChat"
                        :usuario-online="usuarioOnline"
                        :ehPerfilComprador="ehPerfilComprador"
                        :destinatario="destinatarioConversacao"
                        @enviarMensagem="(mensagem) => $emit('enviarMensagem', mensagem)"></acoes-enviar-mensagem>
                </div>
            </v-slide-y-transition>
        </v-sheet>
    </v-scale-transition>
</template>

<script>
import AcoesEnviarMensagem from '@/views/pages/commons/chat-compra-direta/chat-area/AcoesEnviarMensagem'
import ChatMensagemContainer from '@/views/pages/commons/chat-compra-direta/chat-area/ChatMensagemContainer'
import ChatMensagem from '@/views/pages/commons/chat-compra-direta/chat-area/ChatMensagem'
import {mapState} from 'vuex'
import ChatItemLoteLista from '@/views/pages/commons/chat-compra-direta/chat-area/iten-lotes/ChatItemLoteLista'
import ChatItemLote from '@/views/pages/commons/chat-compra-direta/chat-area/iten-lotes/ChatItemLote'
import ChatItemLoteFornecedor from '@/views/pages/commons/chat-compra-direta/chat-area/iten-lotes/ChatItemLoteFornecedor'

/**
 * TODO
 *      1- Reorganizar as ações do chat, para que sejam tratadas em escope Comprador|Fornecedor,
 *          ao invés do escopo global do chat. Isto é, tratar por eventos as ação que são efetuadas no
 *          componente ChatSheet. Aquelas que são possíveis.
 *      2- Centralizar algumas ações, por exemplo, criar o destinatário, detalhes, abrir chat, buscar mensagens, etc...
 *      3- Reorganizar código repetido.
 *      4- Escolher a formar de processar subscribe para mensagens, use USUARIO ou ORGÃO|PESSOA
 *
 *      ## 1 - Quando desclassificar um fornecedor, bloqueiar envio de mensagens tanto para comprador,
 *             quanto para fornecedor
 *
 */
export default {
    name: 'ChatSheet',
    components: {
        ChatItemLoteFornecedor,
        ChatItemLote, ChatItemLoteLista, ChatMensagem, ChatMensagemContainer, AcoesEnviarMensagem},
    props: {
        resultados: {
            type: Array,
            required: true
        },
        ehPerfilComprador: {
            type: Boolean,
            required: true
        }
    },
    computed: {
        ...mapState(['chat', 'loki']),
        mensagensConversacao(){
            return this.chat.conversacao.mensagens
        },
        destinatarioConversacao(){
            return this.chat.conversacao.destinatario
        },
        conversacaoCompraDetalhes(){
            return this.chat.conversacao.compra
        },
        itemOuLoteAtualDoChat(){
            return this.chat.conversacao.itemOuLoteAtualDoChat
        },
        usuarioOnline(){
            return {
                id: this.loki.user.id,
                domainType: this.loki.user.domainType,
                dominioId: this.loki.user.domainId,
            }
        },
    }
}
</script>

<style scoped lang="stylus">
    .acoes-enviar-mensagem
        background-color white
        height auto
        max-height 400px
        position absolute
        bottom 0
        left 0
        right 0


    .chat-sheet-header
        background-color var(--v-primary-base)
        height 80px

    .chat-sheet-header *
        color var(--v-secondary-lighten3) !important

    .sheet-chat-container
        position: fixed
        bottom 10px !important
        right 10px !important
        height calc(100vh - 200px) !important
        z-index 999999
        box-shadow 2px 2px 5px 5px lightgrey
        overflow-y word-break

</style>